define.alias("shared/components/shared/wizard/slide-count", "media/components/shared/wizard/slide-count");